import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import durationSetup from "moment-duration-format";
import Icon from "../Common/Icon";
import { connect } from "react-redux";
import actions from "../../actions/reisadviezen";
import scrollTo from "../../utils/scrollTo";
import { getIsRequiredFlexLoading } from "../../utils/flexRules";
import connection from "../../api/config/connection";
import { format } from "date-fns";
import { getOccupancySpan } from "../../utils/shared";
durationSetup(moment);

class List extends Component {
  static propTypes = {
    config: PropTypes.object,
  };

  constructor() {
    super();
    this.listRef = React.createRef();
    this.prevBtnRef = React.createRef();
    this.nextBtnRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {
    window.addEventListener("resize", this.queueUpdateScrollInfo, {
      passive: true,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.queueUpdateScrollInfo);
  }

  queueUpdateScrollInfo = () => {
    if (this.updateScrollInfoTimeout) {
      clearTimeout(this.updateScrollInfoTimeout);
    }
    this.updateScrollInfoTimeout = setTimeout(
      this.updateScrollInfo(
        null,
        this.props.reachedStartOfDay,
        this.props.reachedEndOfDay
      ),
      400
    );
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    prevState = prevState === null ? {} : prevState;
    return {
      loading: nextProps.loading,
      loaded: !nextProps.loading && prevState.loading,
    };
  }

  componentDidUpdate(prevProps) {
    const list = this.listRef.current;
    if (list) {
      list.addEventListener("scroll", this.queueUpdateScrollInfo, {
        passive: true,
      });
    }

    const {
      selectedIndex,
      // startPageIndex,
      // endPageIndex
    } = this.props;
    const loaded = this.state.loaded;

    if (list && loaded) {
      const items = this.getItemsOfList();
      scrollTo.scrollToIndex(list, items, selectedIndex);
      this.updateScrollInfo();
    }

    if (this.props.reachedEndOfDay) {
      this.updateScrollInfo(null, false, true);
    }

    if (this.props.reachedStartOfDay) {
      this.updateScrollInfo(null, true, false);
    }

    if (
      this.props.noNextResponseForInterval &&
      this.props.numberOfEmptyIntervals !== prevProps.numberOfEmptyIntervals
    ) {
      this.handleRequest("NEXT");
    }

    if (
      this.props.noPrevResponseForInterval &&
      this.props.numberOfEmptyIntervals !== prevProps.numberOfEmptyIntervals
    ) {
      this.handleRequest("PREV");
    }
  }

  getItemsOfList() {
    return this.listRef.current.querySelectorAll(`.reisadviezen__item`);
  }

  render() {
    const { config, selectedIndex, plans, targetIsArrivalTime, loading } =
      this.props;
    let {
      previousText = "Eerder",
      previousScreenReaderText = "Eerdere reisadviezen",
      nextText = "Later",
      nextScreenReaderText = "Eerdere reisadviezen",
      departmentTimeText = "Vertrek tijd",
      arrivalTimeText = "Aankomst tijd",
      transfersText = "Aantal overstappen",
      durationText = "Reisduur",
      priceText = "Prijs",
      minutesDelayText = "minuten vertraging",
      noPlansText = "Er kon geen reisadvies worden gegeven. Wijzig de reis in het formulier hierboven.",
      noPlansHeading = "Reguliere reisresultaten",
    } = config;

    const leftText = targetIsArrivalTime ? nextText : previousText;
    const leftScreenReaderText = targetIsArrivalTime
      ? nextScreenReaderText
      : previousScreenReaderText;
    const rightText = targetIsArrivalTime ? previousText : nextText;
    const rightScreenReaderText = targetIsArrivalTime
      ? previousScreenReaderText
      : nextScreenReaderText;

    const show = !loading;
    const hasPlans = plans && plans.length !== 0;

    return (
      <React.Fragment>
        <div className="theme--accent theme--accent-dark">
          <div
            className={`reisadviezen ${loading ? "reisadviezen--loading" : ""}`}
          >
            <div className="reisadviezen__container">
              {!show ? null : !hasPlans ? (
                <div className="reisadviezen__no-items-message">
                  <h3>{noPlansHeading}</h3>
                  <p>{noPlansText}</p>
                </div>
              ) : (
                <React.Fragment>
                  <button
                    ref={this.prevBtnRef}
                    // {...(this.is9292 &&
                    // this.reachedStart &&
                    // this.props.reachedStartOfDay
                    //   ? { disabled: "disabled" }
                    //   : {})}
                    className={`reisadviezen__nav-btn reisadviezen__nav-btn--prev ${
                      this.props.prevItinerariesLoading
                        ? "reisadviezen__nav-btn--loading btn--disabled btn--loading"
                        : ""
                    } ${
                      this.props.prevItinerariesLoading
                        ? " btn--disabled btn--loading"
                        : ""
                    } ${this.reachedStart ? "btn--disabled" : ""}`}
                    type="button"
                    onClick={this.handlePrevPage}
                  >
                    <Icon
                      className="reisadviezen__nav-icon reisadviezen__nav-icon--loading"
                      iconName="loading-light"
                    />
                    <Icon
                      className="reisadviezen__nav-icon"
                      iconName="arrow-left"
                    />
                    <span className="mobile-hide" aria-hidden="true">
                      {leftText}
                    </span>
                    <span className="sr-only">({leftScreenReaderText})</span>
                  </button>
                  <ul className="reisadviezen__list" ref={this.listRef}>
                    {plans.map((plan, i) => {
                      let startTimeDelay = plan.startTimeDelay
                        ? Math.round(plan.startTimeDelay / 1000 / 60)
                        : 0;
                      let endTimeDelay = plan.endTimeDelay
                        ? Math.round(plan.endTimeDelay / 1000 / 60)
                        : 0;

                      const tabIndex = plan.cancelled ? -1 : "";
                      return (
                        <li
                          className={`reisadviezen__item ${
                            plan.cancelled
                              ? "reisadviezen__item--cancelled"
                              : ""
                          }`}
                          key={`${i}`}
                        >
                          <button
                            className={`reisadviezen__item-btn ${
                              i === selectedIndex ? "is-active" : ""
                            }`}
                            type="button"
                            tabIndex={tabIndex}
                            onClick={() => this.handleItemSelected(plan, i)}
                          >
                            <span className="reisadviezen__item-info">
                              <span className="reisadviezen__department-time">
                                <Icon
                                  className="reisadviezen__department-time-icon"
                                  iconName="arrow-right"
                                  title={departmentTimeText}
                                />
                                <span>
                                  {format(plan.startTime, "HH:mm")}
                                  {startTimeDelay ? (
                                    <span className="reisadviezen__time-adjustment">
                                      {" "}
                                      +{startTimeDelay}{" "}
                                      <span className="sr-only">
                                        {" "}
                                        {minutesDelayText}
                                      </span>
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </span>
                              <span className="reisadviezen__arrival-time">
                                <span className="sr-only">
                                  {arrivalTimeText}
                                </span>
                                <span>
                                  {format(plan.endTime, "HH:mm")}
                                  {endTimeDelay ? (
                                    <span className="reisadviezen__time-adjustment">
                                      {" "}
                                      +{endTimeDelay}{" "}
                                      <span className="sr-only">
                                        {" "}
                                        {minutesDelayText}
                                      </span>
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </span>
                              <span className="reisadviezen__transfers">
                                <Icon
                                  className="reisadviezen__transfers-icon"
                                  iconName="transfers"
                                  title={transfersText}
                                />
                                {plan.transfers}
                              </span>
                              <span className="reisadviezen__duration">
                                <Icon
                                  className="reisadviezen__duration-icon"
                                  iconName="clock"
                                  title={durationText}
                                />
                                {moment
                                  .duration(plan.duration, "milliseconds")
                                  .format("H:mm", {
                                    forceLength: true,
                                    trim: "small",
                                  })}
                              </span>
                              <span className="reisadviezen__price">
                                <span className="sr-only">{priceText}</span>
                                <span className="reisadviezen__price-currency">
                                  &euro;
                                </span>
                                {plan.fare
                                  ? Number(plan.fare.price)
                                      .toFixed(2)
                                      .replace(".", ",")
                                  : "?"}
                              </span>
                              {getOccupancySpan(
                                "reisadviezen__occupancy",
                                plan.occupancy
                              )}
                            </span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                  <button
                    ref={this.nextBtnRef}
                    // {...(!this.is9292 && this.reachedEnd && this.reachedEndOfDay
                    //   ? { disabled: "disabled" }
                    //   : {})}
                    className={`reisadviezen__nav-btn reisadviezen__nav-btn--next ${
                      this.props.nextItinerariesLoading
                        ? "reisadviezen__nav-btn--loading"
                        : ""
                    } ${
                      this.props.nextItinerariesLoading
                        ? " btn--disabled btn--loading"
                        : ""
                    } ${this.reachedEnd ? "btn--disabled" : ""}`}
                    type="button"
                    onClick={this.handleNextPage}
                  >
                    <span className="mobile-hide" aria-hidden="true">
                      {rightText}
                    </span>
                    <span className="sr-only">{rightScreenReaderText}</span>
                    <Icon
                      className="reisadviezen__nav-icon"
                      iconName="arrow-right"
                    />
                    <Icon
                      className="reisadviezen__nav-icon reisadviezen__nav-icon--loading"
                      iconName="loading-light"
                    />
                  </button>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  handlePrevPage = () => {
    const items = this.getItemsOfList();
    const scrollInfo = scrollTo.scrollByPages(this.listRef.current, items, -1);

    var noMorePrevData = null;
    if (this.props.reachedStartOfDay) {
      noMorePrevData = true;
    } else if (scrollInfo.reachedStart) {
      noMorePrevData = this.handleRequest("PREV");
    }
    this.updateScrollInfo(scrollInfo, noMorePrevData, false);
  };

  handleNextPage = () => {
    const items = this.getItemsOfList();
    const scrollInfo = scrollTo.scrollByPages(this.listRef.current, items, 1);

    var noMoreNextData = null;

    if (this.props.reachedEndOfDay) {
      noMoreNextData = true;
    } else if (scrollInfo.reachedEnd) {
      noMoreNextData = this.handleRequest("NEXT");
    }

    this.updateScrollInfo(scrollInfo, false, noMoreNextData);
  };

  handleRequest = (nextOrPrev) => {
    if (this.props.plannerType !== "otp2") return null;
    var requestTime = null;

    if (nextOrPrev === "NEXT") {
      requestTime = new Date(this.props.nextTime);
    } else if (nextOrPrev === "PREV") {
      requestTime = new Date(this.props.prevTime);
    } else return null;

    var requestDate = requestTime.getDate();
    var newValues = this.props.formValues;

    if (this.props.oneRequestBeforeMidNight && nextOrPrev === "NEXT") {
      newValues["date"] = this.props.selectedDate;
    }

    var currentDate = parseInt(
      moment(this.props.formValues["date"], "DD-MM-YYYY").format("DD")
    );

    var timeString = format(requestTime, "HH:mm");
    newValues["time"] = timeString;

    if (nextOrPrev === "PREV" && this.props.oneRequestBeforeMidNight)
      return true;
    if (requestDate !== currentDate && nextOrPrev === "NEXT") return true;

    if (nextOrPrev === "PREV" && this.props.oneRequestBeforeMidNight === true) {
      return true;
    } else if (requestDate != currentDate && nextOrPrev === "PREV") {
      this.props.requestBeforeMidnight();
      var yesterdayDate = format(requestTime, "dd-MM-yyyy");
      newValues["date"] = yesterdayDate;
    }

    if (nextOrPrev == "NEXT") {
      this.props.requestNext();
      this.props.receivedNext(
        newValues,
        this.props.formConfig,
        this.props.selectedDate,
        connection.instance()
      );
    } else {
      this.props.requestPrev();
      this.props.receivedPrev(
        newValues,
        this.props.formConfig,
        this.props.selectedDate,
        connection.instance()
      );
    }
    return false;
  };

  updateScrollInfo = (
    scrollInfo,
    noMorePrevData = null,
    noMoreNextData = null
  ) => {
    this.scrollEndedListenerTimeout = undefined;
    if (!this.listRef.current) return;

    if (!scrollInfo) {
      scrollInfo = scrollTo.getScrollInfo(
        this.listRef.current,
        this.getItemsOfList()
      );
    }

    // var currentIndex = scrollInfo.currentIndex;
    // var nextIndex = currentIndex + this.props.prevBatchLength - this.props.nextBatchLength;
    // this.props.cleanBatch();

    // scrollTo.scrollToIndex(this.listRef.current, this.getItemsOfList(), nextIndex);

    this.reachedStart = scrollInfo.reachedStart;

    if (
      scrollInfo.reachedStart &&
      (this.props.plannerType === "otp2" ? noMorePrevData : true)
    ) {
      this.prevBtnRef.current.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnRef.current.removeAttribute("disabled");
    }

    this.reachedEnd = scrollInfo.reachedEnd;

    if (
      scrollInfo.reachedEnd &&
      (this.props.plannerType == "otp2" ? noMoreNextData : true)
    ) {
      this.nextBtnRef.current.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnRef.current.removeAttribute("disabled");
    }
  };

  // async loadPrevResults() {
  //   const { startPageIndex } = this.props;
  //   this.loadPage(startPageIndex - 1);
  // }

  // async loadNextResults() {
  //   const { endPageIndex } = this.props;
  //   this.loadPage(endPageIndex + 1);
  // }

  // is9292 = () => (this.props.plannerType === '9292')

  // async loadPage(pageIndex = 1) {
  //   if (!this.is9292()) {
  //     return console.warn('OTP plannerstack not yet implemented');
  //   }

  //   try {
  //     const {
  //       loading,
  //       formConfig,
  //       formValues
  //     } = this.props;
  //     if (loading) return;

  //     const values = { ...formValues };
  //     let newDateTime = moment(`${values.date} ${values.time}`, 'DD-MM-YYYY HH:mm');
  //     if (this.is9292()) {
  //       newDateTime = newDateTime.add(pageIndex, 'hours');
  //     } else {
  //       console.warn('OTP plannerstack not yet implemented');
  //       return;
  //     }
  //     console.log('date was:', values.date)
  //     console.log('time was:', values.time)
  //     values.date = newDateTime.format('DD-MM-YYYY');
  //     values.time = newDateTime.format('HH:mm');
  //     console.log('date is:', values.date)
  //     console.log('time is:', values.time)

  //     this.props.request();
  //     const axios = connection.instance();
  //     const response = await Form.executeRequest(formConfig, axios, values);
  //     console.log('response', response);
  //     this.props.received(response, formValues, formConfig, pageIndex);
  //     console.log('next results', response, '\ninput:', formValues, formConfig);

  //     this.reachedStart = false;
  //     this.reachedEnd = false;
  //   } catch (ex) {
  //     this.props.failed(true);
  //     console.error(ex);
  //   }
  // }

  handleItemSelected = (item, i) => {
    this.props.select(i);
    if (this.listRef.current) {
      const list = this.listRef.current;
      const items = this.listRef.current.childNodes;
      const listContainsTwoItems =
        list.clientWidth >= scrollTo.getItemWidth(items[0]) * 2;
      const index = i - (listContainsTwoItems ? 1 : 0);
      scrollTo.scrollToIndex(list, items, index);
    }
  };
}

export default connect(
  (state) => {
    const {
      formConfig,
      formValues,
      metadata,
      prevTime,
      nextTime,
      noNextResponseForInterval,
      noPrevResponseForInterval,
      numberOfEmptyIntervals,
      prevBatchLength,
      nextBatchLength,
      oneRequestBeforeMidNight,
      prevItinerariesLoading,
      nextItinerariesLoading,
      loading,
      plans,
      plannerType,
      targetIsArrivalTime,
      selectedIndex,
      startPageIndex,
      endPageIndex,
      selectedDate,
      reachedStartOfDay,
      reachedEndOfDay,
    } = state.reisadviezen;

    return {
      formConfig,
      formValues,
      metadata,
      prevTime,
      nextTime,
      noNextResponseForInterval,
      noPrevResponseForInterval,
      numberOfEmptyIntervals,
      prevBatchLength,
      nextBatchLength,
      oneRequestBeforeMidNight,
      prevItinerariesLoading,
      nextItinerariesLoading,
      loading: loading || getIsRequiredFlexLoading(state),
      plans,
      plannerType,
      targetIsArrivalTime,
      selectedIndex,
      startPageIndex,
      endPageIndex,
      selectedDate,
      reachedStartOfDay,
      reachedEndOfDay,
    };
  },
  {
    select: actions.select,
    cleanBatch: actions.cleanBatch,
    requestBeforeMidnight: actions.requestBeforeMidnight,
    request: actions.request,
    received: actions.received,
    failed: actions.failed,
    requestNext: actions.requestNext,
    requestPrev: actions.requestPrev,
    receivedPrev: actions.receivedPrev,
    receivedNext: actions.receivedNext,
  }
)(List);



// WEBPACK FOOTER //
// ./src/components/Reisadviezen/List.js